import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import Sidebar from '../Sidebar/Sidebar';
import "./CreatePharmacyBranch.css";

const CreatePharmacyBranch = () => {
  const [formData, setFormData] = useState({
    branch_name: "",
    email: "",
    phone_number: "",
    user_name: "",
    hashed_password: "",
    branch_address: "",
    opening_hours: "",
    supervising_pharmacist_name: "",
    supervising_pharmacist_license: "",
    latitude: "",
    longitude: "",
    state: "",
    city: "",
    country: "",
  });

  const [fieldErrors, setFieldErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [generalMessage, setGeneralMessage] = useState("");

  const inputRefs = useRef({});
  const token = localStorage.getItem("access_token");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setFieldErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
    setGeneralMessage("");
  };

  const scrollToFirstError = () => {
    const firstErrorField = Object.keys(fieldErrors).find((key) => fieldErrors[key]);
    if (firstErrorField && inputRefs.current[firstErrorField]) {
      inputRefs.current[firstErrorField].scrollIntoView({ behavior: "smooth", block: "center" });
      inputRefs.current[firstErrorField].focus();
    }
  };

  useEffect(() => {
    if (Object.keys(fieldErrors).length > 0) {
      scrollToFirstError();
    }
  }, [fieldErrors]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setGeneralMessage("");
    setFieldErrors({});

    const payload = {
      branch_name: formData.branch_name,
      email: formData.email,
      phone_number: formData.phone_number,
      user_name: formData.user_name,
      hashed_password: formData.hashed_password,
      branch_address: formData.branch_address,
      opening_hours: formData.opening_hours,
      supervising_pharmacist_name: formData.supervising_pharmacist_name,
      supervising_pharmacist_license: formData.supervising_pharmacist_license,
      latitude: parseFloat(formData.latitude) || 0,
      longitude: parseFloat(formData.longitude) || 0,
      state: formData.state,
      city: formData.city,
      country: formData.country,
    };

    try {
      const response = await axios.post(
        "http://127.0.0.1:8000/users/pharmacy-branch/create",
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      setGeneralMessage("✅ Pharmacy branch created successfully!");
      console.log(response.data);

      setFormData({
        branch_name: "",
        email: "",
        phone_number: "",
        user_name: "",
        hashed_password: "",
        branch_address: "",
        opening_hours: "",
        supervising_pharmacist_name: "",
        supervising_pharmacist_license: "",
        latitude: "",
        longitude: "",
        state: "",
        city: "",
        country: "",
      });
      setFieldErrors({});
    } catch (error) {
      const detail = error.response?.data?.detail;
      console.log("API error detail:", detail);

      if (Array.isArray(detail)) {
        const newFieldErrors = {};
        detail.forEach((err) => {
          const field = err.loc && err.loc.length > 1 ? err.loc[1] : null;
          if (field) {
            let normalizedField = field;
            if (field === "phone") normalizedField = "phone_number";
            newFieldErrors[normalizedField] = err.msg;
          }
        });
        setFieldErrors(newFieldErrors);
      } else if (typeof detail === "string") {
        const lowerDetail = detail.toLowerCase();

        if (lowerDetail.includes("email")) {
          setFieldErrors({ email: detail });
        } else if (lowerDetail.includes("phone")) {
          setFieldErrors({ phone_number: detail });
        } else if (lowerDetail.includes("username") || lowerDetail.includes("user_name")) {
          setFieldErrors({ user_name: detail });
        } else {
          setGeneralMessage(detail);
        }
      } else {
        setGeneralMessage("❌ Failed to create pharmacy branch");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <Sidebar />

      <main className="main-content">
        <h1 className="title">🏪 Create Pharmacy Branch</h1>

        <form onSubmit={handleSubmit} className="branch-form" noValidate>
          {Object.keys(formData).map((key) => (
            <div key={key} className="form-group">
              <label htmlFor={key}>{key.replace(/_/g, " ")}</label>
              <input
                id={key}
                ref={(el) => (inputRefs.current[key] = el)}
                type={key.includes("password") ? "password" : "text"}
                name={key}
                value={formData[key]}
                onChange={handleChange}
                required={!["latitude", "longitude"].includes(key)}
                aria-describedby={`${key}-error`}
                aria-invalid={!!fieldErrors[key]}
              />
              {fieldErrors[key] && (
                <div id={`${key}-error`} className="error-text">
                  {fieldErrors[key]}
                </div>
              )}
            </div>
          ))}

          <div className="form-actions">
            <button type="submit" disabled={loading} className="submit-btn">
              {loading ? "Creating..." : "Create Branch"}
            </button>

            {generalMessage && generalMessage.startsWith("✅") && (
              <div className="success-message-inline">
                {generalMessage}
              </div>
            )}
          </div>
        </form>
      </main>

      {loading && (
        <div className="loading-overlay">
          <div className="spinner"></div>
        </div>
      )}
    </div>
  );
};

export default CreatePharmacyBranch;
